import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { TracingContextService } from "@core/services/tracing/tracing-context.service";
import { BusinessFrontService } from "@core/services/business-front/business-front.service";
import { NavbarLogoComponent } from "@shared/components/navbars/navbar-logo/navbar-logo.component";
import { ToastComponent } from "@shared/components/toast/toast.component";
import { AnalyticsService } from "@shared/services/analytics/analytics.service";
import { AntiFraudService } from "@shared/services/anti-fraud/anti-fraud.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [RouterOutlet, ToastComponent, NavbarLogoComponent],
})
export class AppComponent implements OnInit {
  private businessFrontService = inject(BusinessFrontService);
  private analyticsService = inject(AnalyticsService);
  private antiFraudService = inject(AntiFraudService);
  private tracingContextService = inject(TracingContextService);

  ngOnInit(): void {
    this.tracingContextService.initFromUrl();
    this.businessFrontService.setBusinessFront("vss");
    this.analyticsService.initScreenViewRouting();
    this.antiFraudService.initScreenViewRouting();
  }
}
